import { Injectable, NgZone } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { mergeMapTo, mergeMap, distinctUntilChanged } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { GenerateRouteService } from './generate-route.service';
import { decodedToken } from '../helpers/token.helper';
import { get } from 'lodash';
import { PORTALTYPE } from '../helpers/enum.helper';
import { NotificationsService } from 'app/modules/admin/notification/notification.service';



@Injectable()
export class MessagingService {

    currentMessage = new BehaviorSubject(null);
    removeMessage = new BehaviorSubject(null);
    reloadNotificationList = new BehaviorSubject(null);
    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService,
        private router: Router,
        private ngZone: NgZone,
        private generateRouteService: GenerateRouteService,
        private angularFireMessaging: AngularFireMessaging,
        private notificationsService : NotificationsService) {
        this.permission = this.isSupported() ? 'default' : 'denied';
        this.requestPermissions();
        
    }
    
    /**
     * request permission for notification from firebase cloud messaging
     *
     * @param userId userId
     */
    requestPermission(userId) {
        this.angularFireMessaging.requestToken.subscribe(
            (token) => {
                console.log('-- FCM Token -- ', token);
                const tokens = decodedToken();
                var type = get(tokens, 'type')
                this.sendFCMToken(token);
            }, (err) => {
                console.error('Unable to get permission to notify.', err);
            }
        );
    }

    sendFCMToken(token) {
        let obj = { token: token }
        const tokens = decodedToken();
        if(tokens){
            return this.httpClient.post((tokens?.portal == PORTALTYPE.ADMIN ? (environment.phpAPIURL + 'AP/update/fcmToken') :  (environment.employeeapiURL + 'AP/update/fcmToken')), obj)
            .toPromise()
            .then(this.handleData)
            .catch(this.handleError);
        }
    }

    private handleData(res: any) {
        const body = res;
        return body || {};
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

 /**
     * hook method when new notification received in Background
     */

    // receiveMsgBackground(){
    //     this.angularFireMessaging.
    // }
    /**
     * hook method when new notification received in foreground
     */

    receiveMessage() {
        this.angularFireMessaging.messages.subscribe(
            (payload) => {
                const notifyMsg = payload['data'];
                if (notifyMsg) {
                    notifyMsg.title = notifyMsg.title ? notifyMsg.title : '';
                    notifyMsg.data = notifyMsg.data ? JSON.parse(notifyMsg.data) : '';
                    this.notify(notifyMsg.title, {
                        body: notifyMsg.body, icon: 'assets/images/favicon.png',
                        page: notifyMsg.page, data: notifyMsg.data, portal: notifyMsg.portal
                    });
                    this.currentMessage.next(notifyMsg);
                    this.reloadNotificationList.next(notifyMsg);
                   // this.appendQueueCount(1);
                } else {
                    let trackingNotify = payload['notification']
                    this.notify(trackingNotify.title, { body: trackingNotify.body, icon: 'assets/images/favicon.png' })
                }
            });
    }

    appendQueueCount(num) {
        let count;
        this.generateRouteService.getQueueCount()
            .subscribe(res => {
                count = res;
            });
        const append = (num) ? (count + 1) : (count - 1);
        this.generateRouteService.setQueueCount(append);
    }

    requestPermissions(): void {
        let self = this;
        if ('Notification' in window) {
            Notification.requestPermission(function (status) {
                return self.permission = status;
            });
        }
    }

    public permission: Permission;

    public isSupported(): boolean {
        return 'Notification' in window;
    }

    notify(title, options) {
        this.generateNotification(title, options);
    }

    generateNotification(title, options): void {
        let self = this;
        let notify = self.create(title, options).subscribe();
    }

    create(title: string, options?: PushNotification): any {
        let self = this;
        return new Observable((obs) => {
            if (!('Notification' in window)) {
                // console.log('Notifications are not available in this environment');
                obs.complete();
            }
            if (self.permission !== 'granted') {
                // console.log("The user hasn't granted you permission to send push notifications");
                obs.complete();
            }
            let _notify = new Notification(title, options);
            _notify.onshow = (e) => { return obs.next({ notification: _notify, event: e }); };
            _notify.onclick = (e) => {
                this.ngZone.run(() => {
                    let parsedData = (options['data']);
                    this.notificationRead(parsedData);
                });
                _notify.close();
            };
            _notify.onerror = (e) => { return obs.error({ notification: _notify, event: e }); };
            _notify.onclose = function () { return obs.complete(); };
        });
    }

    notificationRead(parsedData){
            let formData = {
              randomId: parsedData?.random_id,
              type:'single'
            }
            this.notificationsService.readNotification(formData).subscribe((res: any) => {
             this.reloadNotificationList.next(true);
            }, (err: any) => {
            })
          this.generateRouteService.notificationNavigate(parsedData?.portal,parsedData?.page,parsedData);
    }

    onLogout(){
        const tokens = decodedToken();
        return this.httpClient.post((tokens?.portal == 'admin' ? environment.apiURL :  environment.employeeapiURL)  + 'userUpdateToken', null)
    }

}

export declare type Permission = 'denied' | 'granted' | 'default';

export interface PushNotification {
    body?: string;
    icon?: string;
    tag?: string;
    data?: any;
    renotify?: boolean;
    silent?: boolean;
    sound?: string;
    noscreen?: boolean;
    sticky?: boolean;
    dir?: 'auto' | 'ltr' | 'rtl';
    lang?: string;
    vibrate?: number[];
}